<!--
 * @Description:
 * @version:
 * @Author: sunqian_sr
 * @Date: 2023-01-10 10:58:12
 * @LastEditors: Andy
 * @LastEditTime: 2023-01-10 18:01:59
-->
<template>
  <div> </div>
</template>
<script>
  export default {
    name: 'CommonUpload',
    props: {},
    data() {
      return {
        visible: false
      }
    },
    methods: {
      handleClose() {
        this.visible = false
      }
    }
  }
</script>
